<template>
<div class="foot-wrapper">
  <div class="tabel-footer">
    <div>
      <slot name="Bottom" />
      <slot name="left" />
    </div>
    <div v-show="showSizeControl"
      class="page-rank"
    >
      <el-popover placement="top-start" v-model="visible">
        <div>
          <div class="popup-menu-wrapper page-popup"
            style="position:relative;margin:-20px;"
          >
            <div v-for="(item,index) in pageSizeList"
              :key="index" class="popup-menu" @click="sizeChange(item)"
            >
              {{ item }}条/页
            </div>
          </div>
        </div>
        <div slot="reference"
          class="cur-length"
        >
          {{ size }}条/页<i class="el-icon-arrow-down"></i>
        </div>
      </el-popover>
    </div>
  </div>
  <el-pagination class="list-footer-page"
    background layout="prev, pager, next,jumper" :total="total" :page-size="size" :page-count="page"
    :current-page="page"
    @current-change="pageChange"
  />
</div>
</template>
<script>
export default {
  name: 'Footpage',
  props: {
    size: {
      type: Number,
      default: 10,
    },
    page: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    showSizeControl: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      pageSizeList: [10, 20, 50, 100],
      visible: false,
    };
  },
  methods: {
    sizeChange (newsize) {
      if (newsize !== this.size) this.$emit('sizeChange', newsize);
      this.visible = false;
    },
    pageChange (newpage) {
      if (newpage !== this.page) this.$emit('pageChange', newpage);
    },
  },
};
</script>
<style lang="less" scoped>
.foot-wrapper {
  border: 1px solid #e3ecf5;
  border-top: 0px;
  .tabel-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: #f2f7fb;
    padding: 10px 0 10px 20px;
    position: relative;
    color: rgba(65, 71, 94, 0.7);
    border-bottom: 1px solid #e3ecf5;
    box-sizing: border-box;
    min-height: 41px;
    .page-rank {
      margin-right: 30px;
      cursor: pointer;
    }
  }
  .list-footer-page {
    text-align: center;
    margin: 20px;
  }
  /deep/.el-icon-arrow-down{
    position: relative;
    font-weight: bold;
    margin-left: 10px;
    top:1px;
  }
  .cur-length{
    margin-right: 10px;
  }
}
.popup-menu-wrapper {
  position: absolute;
  font-size: 12px;
  background: #fff;
  border-radius: 4px;
  z-index: 10;
  box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);

  .popup-menu {
      text-align: center;
      position: relative;
      padding: 8px 5px;
      word-break:break-all;
      word-wrap:break-word;
      cursor: pointer;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      &:hover {
          background: rgba(217, 235, 246, .7);
          color: #2ec2ff;
      }

      .popup-right-icon {
          margin-left: 2px;
      }
  }

  .menu-selected {
      background: rgba(217, 235, 246, 0.7);
      color: #2ec2ff;
  }
}

</style>
